// extracted by mini-css-extract-plugin
module.exports = {"container":"_31Gpf","noWrapContainer":"_2Mvdx","logo":"QRO5x","infoButton":"_2HyC9","dark":"vfigi","light":"_2l_1K"};